import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';

import LoginPage from 'pages/auth/Login';
import DashboardLayout from 'layout/Dashboard';
import WhitelistGate from 'components/WhitelistGate';
import NotFound from 'pages/extra-pages/NotFound';

import DashboardDefault from 'pages/dashboard/default';
import Message from 'pages/component-overview/message';
import Whitelist from 'pages/component-overview/whitelist';
import Profile from 'pages/component-overview/profile';
import Account from 'pages/component-overview/account';
import Log from 'pages/component-overview/log';

import { isAuthed } from 'utils/auth';

// Root gate: whitelist nge-block SEMUA halaman
function RootGate() {
  return (
    <WhitelistGate>
      <Outlet />
    </WhitelistGate>
  );
}

// Guard khusus auth: nge-block halaman dashboard dkk
function AuthGuard({ children }) {
  if (!isAuthed()) return <Navigate to="/login" replace />;
  return children;
}

// Guest guard (biar sudah login gak balik ke login)
function GuestGuard({ children }) {
  return isAuthed() ? <Navigate to="/dashboard/default" replace /> : children;
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <RootGate />,
    children: [
      // root redirect
      { index: true, element: <Navigate to="/login" replace /> },

      // login route (guest only)
      {
        path: 'login',
        element: (
          <GuestGuard>
            <LoginPage />
          </GuestGuard>
        )
      },

      // PROTECTED GROUP: semua route yang butuh login taruh di sini
      {
        element: (
          <AuthGuard>
            <DashboardLayout />
          </AuthGuard>
        ),
        children: [
          { path: 'dashboard/default', element: <DashboardDefault /> },
          { path: 'message', element: <Message /> },
          { path: 'whitelist', element: <Whitelist /> },
          { path: 'profile', element: <Profile /> },
          { path: 'account', element: <Account /> },
          { path: 'log', element: <Log /> }
        ]
      },

      // fallback
      { path: '*', element: <NotFound /> }
    ]
  }
]);

export default router;
